"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var ElevatorContext_1 = __importStar(require("./ElevatorContext"));
var Elevator = function (_a) {
    var baseProp = _a.base, children = _a.children;
    var parentCtx = ElevatorContext_1.useElevatorContext();
    var base = fallback_1.default(baseProp, parentCtx.base + 100);
    return react_1.default.createElement(ElevatorContext_1.default.Provider, { value: { base: base } }, children);
};
exports.default = Elevator;
